import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './admin.css';

export default function AdminLogin() {
  const { authenticated, checking, login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  if (!checking && authenticated) {
    const dest = location.state?.from?.pathname || '/admin';
    return <Navigate to={dest} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(username, password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="adm adm-auth">
      <form className="adm-auth-card" onSubmit={handleSubmit}>
        <div className="adm-auth-brand">
          <span className="adm-brand-mark">S</span>
        </div>
        <h1 className="adm-auth-title">Welcome back</h1>
        <p className="adm-auth-sub">Sign in to manage the SSSMIL website documents.</p>

        {error && (
          <div className="adm-alert adm-alert-error" role="alert">
            <i className="bi bi-exclamation-circle" />
            <span>{error}</span>
          </div>
        )}

        <label className="adm-field">
          <span className="adm-label">Username</span>
          <input
            className="adm-input"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>

        <label className="adm-field">
          <span className="adm-label">Password</span>
          <span className="adm-input-wrap">
            <input
              className="adm-input adm-input-pw"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="adm-input-toggle"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              title={showPassword ? 'Hide password' : 'Show password'}
            >
              <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} />
            </button>
          </span>
        </label>

        <button type="submit" className="adm-btn adm-btn-primary adm-btn-block adm-btn-lg" disabled={submitting}>
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>

        <a className="adm-auth-back" href="/">
          <i className="bi bi-arrow-left" /> Back to website
        </a>
      </form>
    </div>
  );
}
